<!--
 * @Description: 个体上传发票
 * @Date: 2025-09-16 13:49:53
-->
<template>
  <BaseDialog
    width="950px"
    title="上传发票"
    :model-value="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
  >
    <BaseTextContent>
      <InvoiceDetailIndividualDialogContent
        ref="contentRef"
        v-model="formData"
      />
      <InvoiceDetailIndividualDialogList
        :contentRef="contentRef"
        v-model="formData"
      />
      <InvoiceDetailIndividualDialogForm ref="formRef" v-model="formData" />
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="onCancel">取消</BaseButton>
      <BaseButton @click="onConfirm">确认</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" name="invoice-enterprise-dialog" setup>
import { ref } from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import { makeOutAnInvoice } from '@V/invoice/src/data-source/apis';
import {
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import InvoiceDetailIndividualDialogContent from './invoice-detail-individual-dialog-content.vue';
import InvoiceDetailIndividualDialogList from './invoice-detail-individual-dialog-list.vue';
import InvoiceDetailIndividualDialogForm from './invoice-detail-individual-dialog-form.vue';
import { translator } from '@/utils';

type FormData = MakeOutAnInvoiceParams & NotInvoicedListParams;

const props = withDefaults(
  defineProps<{
    remove?: () => {};
  }>(),
  {
    remove() {
      return () => {
        console.log('remove');
      };
    }
  }
);

const emits = defineEmits<{
  (event: 'success', value: void): void;
}>();

const contentRef = ref();
const formRef = ref();
// 提交数据与列表搜索数据放一起了
const formData = ref<FormData>({
  theSellerId: null,
  itemId: null,
  invoiceType: null,
  openOrderIds: [],
  addressId: null,
  userDefinedOrderType: null,
  imgList: [],
  fileList: [],
  taskAt: '',
  invoiceAmount: null, // 勾选的金额
  stateType: 7, // 写死
  isBaseAsp: 1, // 写死
  auditSign: 0 // 写死
});

const onCancel = () => {
  props.remove();
};
const onConfirm = async () => {
  await Promise.all([contentRef.value.validate(), formRef.value.validate()]);
  if (!formData.value.openOrderIds.length) {
    XrkMessage.error('请选择订单');
    return;
  }
  await makeOutAnInvoice({
    ...formData.value,
    imgList: formData.value.imgList.map(item => {
      return {
        ...item,
        ...(item.invoiceAmount && {
          invoiceAmount: translator.yuan2fen(item.invoiceAmount)
        })
      };
    })
  });
  emits('success');
  props.remove();
};
</script>
